// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.league-match-referees-payment__container {
    padding: var(--space) calc( var(--space-x2) + var(--space-half) );
}

.league-match-referees-payment__match-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--new-gray-background-color);
    border-radius: var(--space-quarter);
    padding: var(--space-half) calc( var(--space-x3) + var(--space-and-half) );
    
}

.league-match-referees-payment__match-info__title.baloa-table-column {
    color: var(--primary-very-dark-color);
    margin-bottom: var(--space);
}

.league-match-referees-payment__match-info__teams {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.league-match-referees-payment__match-info__team,
.league-match-referees-payment__match-info__referee {
    display: flex;
    align-items: center;    
}

.league-match-referees-payment__match-info__referee,
.league-match-referees-payment__role__referee,
.league-match-referees-payment__match-info__team,
.league-match-referees-payment__payment-table__body__team-fee {
    width: 40%;
}

.league-match-referees-payment__payment-table__body__team-fee,
.league-match-referees-payment__payment-table__body__team-btn{
    width: 20%;
}

.league-match-referees-payment__match-info__team-name .baloa-names,
.league-match-referees-payment__match-info__referee-name .baloa-names {
    color: var(--primary-very-dark-color);
    margin-bottom: var(--space-quarter);
}

.league-match-referees-payment__match-info__team-name .baloa-username,
.league-match-referees-payment__match-info__referee-name .baloa-username {
    color: var(--primary-dark-color);
}

.league-match-referees-payment__match-info__teams .baloa-table-column {
    color: var(--basic-gray-color);
}

.league-match-referees-payment__info-text.baloa-table {
    color: var(--primary-dark-color);
    margin: var(--space-and-half) 0 var(--space-half-quarter);
}

.league-match-referees-payment__payment-table__container {
    padding: var(--space-half);
    border: 1px solid var(--new-gray-background-color);
    border-radius: var(--space-quarter);
}

.league-match-referees-payment__payment-table__header,
.league-match-referees-crew__referees-table__header {
    background-color: var(--new-background-color);
    border-radius: var(--space-half);
    padding: var(--space-half) var(--space-and-half);
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.league-match-referees-payment__payment-table__header .baloa-table-column,
.league-match-referees-crew__referees-table__header .baloa-table-column {
    color: var(--basic-gray-color);
    width: 25%;
}

.league-match-referees-payment__payment-table__body {
    padding: 0 var(--space-and-half);
}

.league-match-referees-payment__payment-table__body__team {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--space) 0;    
}

.league-match-referees-crew__referees-table__body-referee {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--space) var(--space-and-half);    
}

.league-match-referees-payment__payment-table__body__team:first-of-type {
    border-bottom: 1px solid var(--new-gray-background-color);
}

.league-match-referees-payment__match-info__team-img span.icon-ball,
.league-match-referees-payment__match-info__referee-img span.icon-ball {
    border-radius: 50%;
    color: var(--white-color);
    font-size: 24px;
    padding: 4px;
}

.league-match-referees-payment__match-info__team-img img,
.league-match-referees-payment__match-info__referee-img img {
    border-radius: 50%;
    width: var(--space-x2);
    height: var(--space-x2);
}

.league-match-referees-payment__match-info__team-img {
    display: flex;
}

.league-match-referees-payment__match-info__teams .league-match-referees-payment__match-info__team:first-of-type .league-match-referees-payment__match-info__team-name {
    margin-left: var(--space-half-quarter);
}

.league-match-referees-payment__match-info__teams .league-match-referees-payment__match-info__team:last-of-type .league-match-referees-payment__match-info__team-name {
    margin-right: var(--space-half-quarter);
}

.league-match-referees-payment__payment-table__body__team .league-match-referees-payment__match-info__team-name,
.league-match-referees-crew__referees-table__body-referee .league-match-referees-payment__match-info__referee-name {
    margin-left: var(--space-half-quarter);
}

.league-match-referees-payment__payment-table__body__team-btn .button {
    padding: var(--space-half) var(--space-and-half);
    font-size: 14px;
    line-height: 16px;
}

.league-match-referees-crew__container {
    margin-top: var(--space-and-half);
}

.league-match-referees-crew__info-text.baloa-table {
    color: var(--primary-dark-color);
    margin: var(--space-half-quarter) 0;    
}

.league-match-referees-crew__referees-table__container {
    padding: var(--space-half);
    border: 1px solid #E7E7E7;
    border-radius: 4px;
}

.league-match-referees-payment__role__referee .baloa-names {
    color: var(--basic-gray-color);
}

.league-match-referees-crew__warning,
.league-match-referees-crew__referees-table__total-amount__warning {
    padding: var(--space-half-quarter);
    border: 1px solid var(--new-gray-background-color);
    border-radius: var(--space-quarter);
    background-color: #FEF6F6;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.league-match-referees-crew__referees-table__total-amount__warning {
    background-color: #EDF2FC;
    margin: var(--space-half) 0 var(--space-half-quarter);
}

.league-match-referees-crew__warning .hubicon-info {
    font-size: calc( var(--space) + var(--space-quarter) );
    margin-right: var(--space-half-quarter);
}

.league-match-referees-crew__warning .hubicon-info:before {
    color: var(--error-color);
}

.league-match-referees-crew__referees-table__total-amount__warning .hubicon-info:before {
    color: #1D5CC9;
}

.league-match-referees-crew__referees-table__total-amount__warning .hubicon-info {
    margin-right: var(--space-half-quarter);
}

.league-match-referees-crew__warning .baloa-table,
.league-match-referees-crew__referees-table__total-amount__warning .baloa-table {
    font-weight: var(--font-medium);
    color: var(--primary-dark-color);
}

.league-match-referees-crew__referees-table__body-empty {
    padding: var(--space-x2);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.league-match-referees-crew__referees-table__body-empty .baloa-table-column {
    color: var(--basic-gray-color);
    margin-bottom: var(--space-half-quarter);
}

.league-match-referees-crew__referees-table__body .primary-button {
    width: 100%;
    grid-template-columns: none;
    grid-template-areas: none;
    text-transform: initial;
}

.league-match-referees-crew__referees-table__total {
    border-radius: var(--space-half);
    border: 1px solid var(--new-gray-background-color);
    padding: var(--space-half);
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    margin-bottom: var(--space-half-quarter);
}

.league-match-referees-crew__referees-table__total-fee {
    display: flex;
    align-items: center;
}

.league-match-referees-crew__referees-table__total-fee .baloa-names {
    color: var(--primary-very-dark-color);
    margin-bottom: var(--space-half);
}

.league-match-referees-crew__referees-table__total-fee  .baloa-names.sub-color{
    color: var(--primary-dark-color);
    font-weight: var(--font-regular);
}

.league-match-referees-crew__referees-table__total-remaining .baloa-table {
    color: var(--primary-dark-color);
}

.league-match-referees-crew__referees-table__body-referee.last {
    border-bottom: none;
}

.league-match-referees-crew__referees-table__body-referee {
    border-bottom: 1px solid var(--new-gray-background-color);
}

.league-match-referees-payment__paid.baloa-table-column,
.league-match-referees-payment__payment-table__body__team-fee .league-match-referees-payment__done.baloa-table-column {
    color: var(--new-green-color);
    padding: var(--space-quarter) var(--space);
    border: 1px solid var(--new-green-color);
    border-radius: var(--space-and-half);
    width: fit-content;
    background-color: rgba(48, 179, 107, 0.1);
}

.league-match-referees-payment__confirmation-label {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var(--space-half-quarter) 0;
    background-color: rgba(48, 179, 107, 0.1);
    border: 1.5px solid var(--new-green-color);
    border-radius: var(--space-quarter);
}

.league-match-referees-payment__confirmation-label .baloa-names {
    color: var(--new-green-color);
    margin-right: var(--space-half-quarter);
}

.league-match-referees-payment__payment-table__body__team-fee{
    position: relative;
    cursor: pointer;
}

.league-match-referees-payment__payment-table__body__tooltip {
    position: absolute;
    padding: var(--space-half-quarter);
    background-color: var(--white-color);
    border-radius: var(--space-half);
    border: 1px solid var(--new-gray-background-color);
    bottom: 76px;
    width: 230px;
    display: none;
}

.league-match-referees-payment__payment-table__body__team-fee:hover .league-match-referees-payment__payment-table__body__tooltip {
    display: block;
}

.league-match-referees-payment__payment-table__body__tooltip::after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    margin-left: -15px;
    bottom: -20px;
    left: 30%;
    box-sizing: border-box;
    border: 10px solid var(--new-gray-background-color);
    border-color: transparent transparent var(--white-color) var(--white-color);
    transform-origin: 0 0;
    transform: rotate(-45deg);
    box-shadow: -1px 1px 1px 0 rgb(0 0 0 / 25%);
}

.league-match-referees-payment__payment-table__body__tooltip.baloa-hyperlink-2 {
    font-weight: var(--font-regular);
    color: var(--primary-dark-color);
    font-size: 15px;
    line-height: 18px;

    
}

.league-match-referees-payment__payment-table__body__team-fee .baloa-names {
    color: var(--primary-very-dark-color);
}

.league-match-referees-payment__payment-table__body__team-fee .baloa-names.no-account {
    text-decoration-line: line-through;
    margin-left: var(--space);
}

.league-match-referees-payment__payment-table__body__team-fee .baloa-table-column {
    color: var(--error-color);
    font-weight: var(--font-regular);
    border: 1px solid var(--error-color);
    border-radius: var(--space-and-half);
    background-color: rgba(255, 81, 91, 0.1);
    padding: var(--space-quarter) var(--space-half-quarter);
    margin-top: var(--space-half);
    width: fit-content;
}

.league-match-referees-payment_team-tooltip{
    position: relative;
    cursor: pointer;
    width: fit-content;
}


.league-match-referees-payment_team-tooltip:hover .league-match-referees-payment_team_body__tooltip {
    display: block;
}

.league-match-referees-payment_team-tooltip .baloa-names {
    color: var(--primary-very-dark-color);
}

.league-match-referees-payment_team-tooltip .baloa-names.no-account {
    text-decoration-line: line-through;
    margin-left: var(--space);
}

.league-match-referees-payment_team_body__tooltip {
    position: absolute;
    padding: var(--space-half-quarter);
    background-color: var(--white-color);
    border-radius: var(--space-half);
    border: 1px solid var(--new-gray-background-color);
    bottom: 46px;
    width: 211px;
    left: -28px;    display: none;
}

.league-match-referees-payment_team_body__tooltip::after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    margin-left: 24px;
    bottom: -20px;
    left: 30%;
    box-sizing: border-box;
    border: 10px solid var(--new-gray-background-color);
    border-color: transparent transparent var(--white-color) var(--white-color);
    transform-origin: 0 0;
    transform: rotate(-45deg);
    box-shadow: -1px 1px 1px 0 rgb(0 0 0 / 25%);
}

.league-match-referees-payment_team_body__tooltip.baloa-hyperlink-2 {
    font-weight: var(--font-regular);
    color: var(--primary-dark-color);
    font-size: 15px;
    line-height: 18px;
}

.league-match-referees-payment__pending_instant_payments-label {
    display: flex;
    gap: var(--space-half);
    align-items: center;
    justify-content: center;
    padding: var(--space-half-quarter) 0;
    background-color:rgba(77, 84, 81, 0.1);
    border: 2px solid var(--primary-dark-color);
    border-radius: var(--space-quarter);
}

.league-match-referees-payment__pending_instant_payments-label .baloa-names {
    color: var(--primary-dark-color);
    margin-right: var(--space-half-quarter);
}

.baloa-payout_status_pending.baloa-table-column {
    color: var(--primary-dark-color);
    font-weight: var(--font-regular);
    border: 1px solid rgba(77, 84, 81, 0.1);
    border-radius: var(--space-and-half);
    background-color: #4D54511A;
    padding: var(--space-quarter) var(--space-half-quarter);
    margin-top: var(--space-half);
    width: fit-content;
}

.league-match-referees-crew__inf_pending_instant_payment{
    display: flex;
    gap: var(--space-half);
    align-items: center;
    justify-content: flex-start;
    background: var(--new-background-color);
    border: 1px solid var(--new-gray-background-color);
    border-radius: 4px;
    padding: var(--space);
}

.league-match-referees-crew__inf_pending_instant_payment .baloa-table{
    color: var(--primary-dark-color);
    font-weight: var(--font-medium);
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-match-referees-payment-modal/LeagueMatchRefereesPaymentModal.styles.css"],"names":[],"mappings":"AAAA;IACI,iEAAiE;AACrE;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kDAAkD;IAClD,mCAAmC;IACnC,0EAA0E;;AAE9E;;AAEA;IACI,qCAAqC;IACrC,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;;IAEI,aAAa;IACb,mBAAmB;AACvB;;AAEA;;;;IAII,UAAU;AACd;;AAEA;;IAEI,UAAU;AACd;;AAEA;;IAEI,qCAAqC;IACrC,mCAAmC;AACvC;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;IAChC,yDAAyD;AAC7D;;AAEA;IACI,0BAA0B;IAC1B,kDAAkD;IAClD,mCAAmC;AACvC;;AAEA;;IAEI,6CAA6C;IAC7C,gCAAgC;IAChC,gDAAgD;IAChD,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;;IAEI,8BAA8B;IAC9B,UAAU;AACd;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,2CAA2C;AAC/C;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;;IAEI,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;;IAEI,sCAAsC;AAC1C;;AAEA;IACI,gDAAgD;IAChD,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,gCAAgC;IAChC,mCAAmC;AACvC;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;IAEI,kCAAkC;IAClC,kDAAkD;IAClD,mCAAmC;IACnC,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,qDAAqD;AACzD;;AAEA;IACI,sDAAsD;IACtD,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;;IAEI,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;IAC9B,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,gCAAgC;IAChC,kDAAkD;IAClD,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;;IAEI,6BAA6B;IAC7B,0CAA0C;IAC1C,wCAAwC;IACxC,oCAAoC;IACpC,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC;IACpC,yCAAyC;IACzC,0CAA0C;IAC1C,mCAAmC;AACvC;;AAEA;IACI,6BAA6B;IAC7B,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,oCAAoC;IACpC,gCAAgC;IAChC,kDAAkD;IAClD,YAAY;IACZ,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,mDAAmD;IACnD,2EAA2E;IAC3E,qBAAqB;IACrB,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;IAChC,eAAe;IACf,iBAAiB;;;AAGrB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;IAChC,oCAAoC;IACpC,oCAAoC;IACpC,wCAAwC;IACxC,uDAAuD;IACvD,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;;AAGA;IACI,cAAc;AAClB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,oCAAoC;IACpC,gCAAgC;IAChC,kDAAkD;IAClD,YAAY;IACZ,YAAY;IACZ,WAAW,KAAK,aAAa;AACjC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,iBAAiB;IACjB,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,mDAAmD;IACnD,2EAA2E;IAC3E,qBAAqB;IACrB,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;IAChC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC;IACpC,sCAAsC;IACtC,2CAA2C;IAC3C,mCAAmC;AACvC;;AAEA;IACI,gCAAgC;IAChC,uCAAuC;AAC3C;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;IAChC,uCAAuC;IACvC,oCAAoC;IACpC,2BAA2B;IAC3B,uDAAuD;IACvD,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,uCAAuC;IACvC,kDAAkD;IAClD,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;AACnC","sourcesContent":[".league-match-referees-payment__container {\n    padding: var(--space) calc( var(--space-x2) + var(--space-half) );\n}\n\n.league-match-referees-payment__match-info {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: var(--space-quarter);\n    padding: var(--space-half) calc( var(--space-x3) + var(--space-and-half) );\n    \n}\n\n.league-match-referees-payment__match-info__title.baloa-table-column {\n    color: var(--primary-very-dark-color);\n    margin-bottom: var(--space);\n}\n\n.league-match-referees-payment__match-info__teams {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.league-match-referees-payment__match-info__team,\n.league-match-referees-payment__match-info__referee {\n    display: flex;\n    align-items: center;    \n}\n\n.league-match-referees-payment__match-info__referee,\n.league-match-referees-payment__role__referee,\n.league-match-referees-payment__match-info__team,\n.league-match-referees-payment__payment-table__body__team-fee {\n    width: 40%;\n}\n\n.league-match-referees-payment__payment-table__body__team-fee,\n.league-match-referees-payment__payment-table__body__team-btn{\n    width: 20%;\n}\n\n.league-match-referees-payment__match-info__team-name .baloa-names,\n.league-match-referees-payment__match-info__referee-name .baloa-names {\n    color: var(--primary-very-dark-color);\n    margin-bottom: var(--space-quarter);\n}\n\n.league-match-referees-payment__match-info__team-name .baloa-username,\n.league-match-referees-payment__match-info__referee-name .baloa-username {\n    color: var(--primary-dark-color);\n}\n\n.league-match-referees-payment__match-info__teams .baloa-table-column {\n    color: var(--basic-gray-color);\n}\n\n.league-match-referees-payment__info-text.baloa-table {\n    color: var(--primary-dark-color);\n    margin: var(--space-and-half) 0 var(--space-half-quarter);\n}\n\n.league-match-referees-payment__payment-table__container {\n    padding: var(--space-half);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: var(--space-quarter);\n}\n\n.league-match-referees-payment__payment-table__header,\n.league-match-referees-crew__referees-table__header {\n    background-color: var(--new-background-color);\n    border-radius: var(--space-half);\n    padding: var(--space-half) var(--space-and-half);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.league-match-referees-payment__payment-table__header .baloa-table-column,\n.league-match-referees-crew__referees-table__header .baloa-table-column {\n    color: var(--basic-gray-color);\n    width: 25%;\n}\n\n.league-match-referees-payment__payment-table__body {\n    padding: 0 var(--space-and-half);\n}\n\n.league-match-referees-payment__payment-table__body__team {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: var(--space) 0;    \n}\n\n.league-match-referees-crew__referees-table__body-referee {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: var(--space) var(--space-and-half);    \n}\n\n.league-match-referees-payment__payment-table__body__team:first-of-type {\n    border-bottom: 1px solid var(--new-gray-background-color);\n}\n\n.league-match-referees-payment__match-info__team-img span.icon-ball,\n.league-match-referees-payment__match-info__referee-img span.icon-ball {\n    border-radius: 50%;\n    color: var(--white-color);\n    font-size: 24px;\n    padding: 4px;\n}\n\n.league-match-referees-payment__match-info__team-img img,\n.league-match-referees-payment__match-info__referee-img img {\n    border-radius: 50%;\n    width: var(--space-x2);\n    height: var(--space-x2);\n}\n\n.league-match-referees-payment__match-info__team-img {\n    display: flex;\n}\n\n.league-match-referees-payment__match-info__teams .league-match-referees-payment__match-info__team:first-of-type .league-match-referees-payment__match-info__team-name {\n    margin-left: var(--space-half-quarter);\n}\n\n.league-match-referees-payment__match-info__teams .league-match-referees-payment__match-info__team:last-of-type .league-match-referees-payment__match-info__team-name {\n    margin-right: var(--space-half-quarter);\n}\n\n.league-match-referees-payment__payment-table__body__team .league-match-referees-payment__match-info__team-name,\n.league-match-referees-crew__referees-table__body-referee .league-match-referees-payment__match-info__referee-name {\n    margin-left: var(--space-half-quarter);\n}\n\n.league-match-referees-payment__payment-table__body__team-btn .button {\n    padding: var(--space-half) var(--space-and-half);\n    font-size: 14px;\n    line-height: 16px;\n}\n\n.league-match-referees-crew__container {\n    margin-top: var(--space-and-half);\n}\n\n.league-match-referees-crew__info-text.baloa-table {\n    color: var(--primary-dark-color);\n    margin: var(--space-half-quarter) 0;    \n}\n\n.league-match-referees-crew__referees-table__container {\n    padding: var(--space-half);\n    border: 1px solid #E7E7E7;\n    border-radius: 4px;\n}\n\n.league-match-referees-payment__role__referee .baloa-names {\n    color: var(--basic-gray-color);\n}\n\n.league-match-referees-crew__warning,\n.league-match-referees-crew__referees-table__total-amount__warning {\n    padding: var(--space-half-quarter);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: var(--space-quarter);\n    background-color: #FEF6F6;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.league-match-referees-crew__referees-table__total-amount__warning {\n    background-color: #EDF2FC;\n    margin: var(--space-half) 0 var(--space-half-quarter);\n}\n\n.league-match-referees-crew__warning .hubicon-info {\n    font-size: calc( var(--space) + var(--space-quarter) );\n    margin-right: var(--space-half-quarter);\n}\n\n.league-match-referees-crew__warning .hubicon-info:before {\n    color: var(--error-color);\n}\n\n.league-match-referees-crew__referees-table__total-amount__warning .hubicon-info:before {\n    color: #1D5CC9;\n}\n\n.league-match-referees-crew__referees-table__total-amount__warning .hubicon-info {\n    margin-right: var(--space-half-quarter);\n}\n\n.league-match-referees-crew__warning .baloa-table,\n.league-match-referees-crew__referees-table__total-amount__warning .baloa-table {\n    font-weight: var(--font-medium);\n    color: var(--primary-dark-color);\n}\n\n.league-match-referees-crew__referees-table__body-empty {\n    padding: var(--space-x2);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n}\n\n.league-match-referees-crew__referees-table__body-empty .baloa-table-column {\n    color: var(--basic-gray-color);\n    margin-bottom: var(--space-half-quarter);\n}\n\n.league-match-referees-crew__referees-table__body .primary-button {\n    width: 100%;\n    grid-template-columns: none;\n    grid-template-areas: none;\n    text-transform: initial;\n}\n\n.league-match-referees-crew__referees-table__total {\n    border-radius: var(--space-half);\n    border: 1px solid var(--new-gray-background-color);\n    padding: var(--space-half);\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    margin-bottom: var(--space-half-quarter);\n}\n\n.league-match-referees-crew__referees-table__total-fee {\n    display: flex;\n    align-items: center;\n}\n\n.league-match-referees-crew__referees-table__total-fee .baloa-names {\n    color: var(--primary-very-dark-color);\n    margin-bottom: var(--space-half);\n}\n\n.league-match-referees-crew__referees-table__total-fee  .baloa-names.sub-color{\n    color: var(--primary-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.league-match-referees-crew__referees-table__total-remaining .baloa-table {\n    color: var(--primary-dark-color);\n}\n\n.league-match-referees-crew__referees-table__body-referee.last {\n    border-bottom: none;\n}\n\n.league-match-referees-crew__referees-table__body-referee {\n    border-bottom: 1px solid var(--new-gray-background-color);\n}\n\n.league-match-referees-payment__paid.baloa-table-column,\n.league-match-referees-payment__payment-table__body__team-fee .league-match-referees-payment__done.baloa-table-column {\n    color: var(--new-green-color);\n    padding: var(--space-quarter) var(--space);\n    border: 1px solid var(--new-green-color);\n    border-radius: var(--space-and-half);\n    width: fit-content;\n    background-color: rgba(48, 179, 107, 0.1);\n}\n\n.league-match-referees-payment__confirmation-label {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: var(--space-half-quarter) 0;\n    background-color: rgba(48, 179, 107, 0.1);\n    border: 1.5px solid var(--new-green-color);\n    border-radius: var(--space-quarter);\n}\n\n.league-match-referees-payment__confirmation-label .baloa-names {\n    color: var(--new-green-color);\n    margin-right: var(--space-half-quarter);\n}\n\n.league-match-referees-payment__payment-table__body__team-fee{\n    position: relative;\n    cursor: pointer;\n}\n\n.league-match-referees-payment__payment-table__body__tooltip {\n    position: absolute;\n    padding: var(--space-half-quarter);\n    background-color: var(--white-color);\n    border-radius: var(--space-half);\n    border: 1px solid var(--new-gray-background-color);\n    bottom: 76px;\n    width: 230px;\n    display: none;\n}\n\n.league-match-referees-payment__payment-table__body__team-fee:hover .league-match-referees-payment__payment-table__body__tooltip {\n    display: block;\n}\n\n.league-match-referees-payment__payment-table__body__tooltip::after {\n    content: \"\";\n    position: absolute;\n    width: 0;\n    height: 0;\n    margin-left: -15px;\n    bottom: -20px;\n    left: 30%;\n    box-sizing: border-box;\n    border: 10px solid var(--new-gray-background-color);\n    border-color: transparent transparent var(--white-color) var(--white-color);\n    transform-origin: 0 0;\n    transform: rotate(-45deg);\n    box-shadow: -1px 1px 1px 0 rgb(0 0 0 / 25%);\n}\n\n.league-match-referees-payment__payment-table__body__tooltip.baloa-hyperlink-2 {\n    font-weight: var(--font-regular);\n    color: var(--primary-dark-color);\n    font-size: 15px;\n    line-height: 18px;\n\n    \n}\n\n.league-match-referees-payment__payment-table__body__team-fee .baloa-names {\n    color: var(--primary-very-dark-color);\n}\n\n.league-match-referees-payment__payment-table__body__team-fee .baloa-names.no-account {\n    text-decoration-line: line-through;\n    margin-left: var(--space);\n}\n\n.league-match-referees-payment__payment-table__body__team-fee .baloa-table-column {\n    color: var(--error-color);\n    font-weight: var(--font-regular);\n    border: 1px solid var(--error-color);\n    border-radius: var(--space-and-half);\n    background-color: rgba(255, 81, 91, 0.1);\n    padding: var(--space-quarter) var(--space-half-quarter);\n    margin-top: var(--space-half);\n    width: fit-content;\n}\n\n.league-match-referees-payment_team-tooltip{\n    position: relative;\n    cursor: pointer;\n    width: fit-content;\n}\n\n\n.league-match-referees-payment_team-tooltip:hover .league-match-referees-payment_team_body__tooltip {\n    display: block;\n}\n\n.league-match-referees-payment_team-tooltip .baloa-names {\n    color: var(--primary-very-dark-color);\n}\n\n.league-match-referees-payment_team-tooltip .baloa-names.no-account {\n    text-decoration-line: line-through;\n    margin-left: var(--space);\n}\n\n.league-match-referees-payment_team_body__tooltip {\n    position: absolute;\n    padding: var(--space-half-quarter);\n    background-color: var(--white-color);\n    border-radius: var(--space-half);\n    border: 1px solid var(--new-gray-background-color);\n    bottom: 46px;\n    width: 211px;\n    left: -28px;    display: none;\n}\n\n.league-match-referees-payment_team_body__tooltip::after {\n    content: \"\";\n    position: absolute;\n    width: 0;\n    height: 0;\n    margin-left: 24px;\n    bottom: -20px;\n    left: 30%;\n    box-sizing: border-box;\n    border: 10px solid var(--new-gray-background-color);\n    border-color: transparent transparent var(--white-color) var(--white-color);\n    transform-origin: 0 0;\n    transform: rotate(-45deg);\n    box-shadow: -1px 1px 1px 0 rgb(0 0 0 / 25%);\n}\n\n.league-match-referees-payment_team_body__tooltip.baloa-hyperlink-2 {\n    font-weight: var(--font-regular);\n    color: var(--primary-dark-color);\n    font-size: 15px;\n    line-height: 18px;\n}\n\n.league-match-referees-payment__pending_instant_payments-label {\n    display: flex;\n    gap: var(--space-half);\n    align-items: center;\n    justify-content: center;\n    padding: var(--space-half-quarter) 0;\n    background-color:rgba(77, 84, 81, 0.1);\n    border: 2px solid var(--primary-dark-color);\n    border-radius: var(--space-quarter);\n}\n\n.league-match-referees-payment__pending_instant_payments-label .baloa-names {\n    color: var(--primary-dark-color);\n    margin-right: var(--space-half-quarter);\n}\n\n.baloa-payout_status_pending.baloa-table-column {\n    color: var(--primary-dark-color);\n    font-weight: var(--font-regular);\n    border: 1px solid rgba(77, 84, 81, 0.1);\n    border-radius: var(--space-and-half);\n    background-color: #4D54511A;\n    padding: var(--space-quarter) var(--space-half-quarter);\n    margin-top: var(--space-half);\n    width: fit-content;\n}\n\n.league-match-referees-crew__inf_pending_instant_payment{\n    display: flex;\n    gap: var(--space-half);\n    align-items: center;\n    justify-content: flex-start;\n    background: var(--new-background-color);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 4px;\n    padding: var(--space);\n}\n\n.league-match-referees-crew__inf_pending_instant_payment .baloa-table{\n    color: var(--primary-dark-color);\n    font-weight: var(--font-medium);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
